import { Component, ViewChild } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { Customer } from 'src/app/core/services/customer.service';
import { DashboardService } from 'src/app/core/services/dashboard.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-access-logs',
  templateUrl: './access-logs.component.html',
  styleUrl: './access-logs.component.scss'
})
export class AccessLogsComponent {

  logs: any = [];
  loading = false;
  error = '';
  term: any;
  breadCrumbItems: Array<{}>;

  editingCustomer: Customer | null = null;
  paymentType: any = ['COD', 'Online'];
  selectedPaymentMode: string = 'COD';
  @ViewChild('dt') table!: Table;

  constructor(
    private dashboardService: DashboardService,
    private toastService: ToastService,
  ) {
    this.breadCrumbItems = [{ label: 'AVSS eSign' }, { label: 'Access Logs', active: true }];
  }

  ngOnInit(): void {
    this.loadLogs({})
  }

  loadLogs(event: LazyLoadEvent) {

    setTimeout(() => {
      this.loading = true;
    });

    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;

    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams = {
      page: page,
      limit: rows,
      search: this.searchText,
      startDate: startDate,
      endDate: endDate
    };
    this.dashboardService.getAccessLogs(queryParams).then((res: any) => {
      this.logs = res || [];
      console.log(this.logs);

      this.totalRecords = res?.totalRecords || 100;
      this.loading = false;
    }, (err: any) => {
      this.loading = false;
      const message = err || 'Unable to load logs';
      this.toastService.showToaster("Failed", message, "error");
    })

  }


  totalRecords = 0;
  rows = 10;
  searchText = '';
  rangeDates: Date[] | null = null;
  filter: any = {
    search: false,
    dateRange: false,
    resetButton: false,
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  filterChange(event: any) {
    this.searchText = event.search;
    this.rangeDates = event.dateRange
    this.table?.reset();
  }

}
